import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';

const navLinks = [
  { href: '#about',      label: 'about' },
  { href: '#projects',   label: 'projects' },
  { href: '#skills',     label: 'skills' },
  { href: '#experience', label: 'experience' },
  { href: '#contact',    label: 'contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname !== '/') {
      // Navigate home first then scroll
      navigate('/');
      setTimeout(() => {
        document.querySelector(href)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else {
      document.querySelector(href)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <a href="/" className={styles.logo} onClick={e => { e.preventDefault(); navigate('/'); }}>
        Mradul<span className={styles.dot}>.</span>
      </a>

      <ul className={styles.links}>
        {navLinks.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              className={styles.navLink}
              onClick={(e) => handleNavClick(e, link.href)}
            >
              {link.label}
              <span className={styles.crayonLine}>
                <svg viewBox="0 0 60 8" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 5 C8 2, 14 7, 22 4 C30 1, 36 6, 44 4 C50 2, 55 6, 58 4"
                    stroke="#C1440E"
                    strokeWidth="2.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1 6 C10 4, 18 7, 28 5 C38 3, 46 7, 58 5"
                    stroke="#C1440E"
                    strokeWidth="1"
                    fill="none"
                    strokeLinecap="round"
                    opacity="0.4"
                  />
                </svg>
              </span>
            </a>
          </li>
        ))}
      </ul>

      <button className={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
        <span className={menuOpen ? styles.hOpen1 : ''} />
        <span className={menuOpen ? styles.hOpen2 : ''} />
        <span className={menuOpen ? styles.hOpen3 : ''} />
      </button>

      {menuOpen && (
        <div className={styles.mobileMenu}>
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} onClick={(e) => handleNavClick(e, link.href)}>
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
